/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Display_BottomInputs */

const en_input_position_display_bottom = /** @type {(inputs: Input_Position_Display_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom`)
};

const fr_input_position_display_bottom = /** @type {(inputs: Input_Position_Display_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas`)
};

const de_input_position_display_bottom = /** @type {(inputs: Input_Position_Display_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unten`)
};

const it_input_position_display_bottom = /** @type {(inputs: Input_Position_Display_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metter il fondo a`)
};

const ru_input_position_display_bottom = /** @type {(inputs: Input_Position_Display_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нижний`)
};

const es_input_position_display_bottom = /** @type {(inputs: Input_Position_Display_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abajo`)
};

const zh_cn2_input_position_display_bottom = /** @type {(inputs: Input_Position_Display_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`底部`)
};

const ja_input_position_display_bottom = /** @type {(inputs: Input_Position_Display_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`底`)
};

const hi_input_position_display_bottom = /** @type {(inputs: Input_Position_Display_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तल`)
};

const pt_pt2_input_position_display_bottom = /** @type {(inputs: Input_Position_Display_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundo`)
};

/**
* | output |
* | --- |
* | "Bottom" |
*
* @param {Input_Position_Display_BottomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_display_bottom = /** @type {((inputs?: Input_Position_Display_BottomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Display_BottomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_display_bottom(inputs)
	if (locale === "de") return de_input_position_display_bottom(inputs)
	if (locale === "it") return it_input_position_display_bottom(inputs)
	if (locale === "ru") return ru_input_position_display_bottom(inputs)
	if (locale === "es") return es_input_position_display_bottom(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_display_bottom(inputs)
	if (locale === "ja") return ja_input_position_display_bottom(inputs)
	if (locale === "hi") return hi_input_position_display_bottom(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_display_bottom(inputs)
	return en_input_position_display_bottom(inputs)
});